import { useEffect } from 'react';

/**
 * Performance optimization component that adds resource hints and optimizations
 * to improve First Contentful Paint and overall load performance
 */
export const PerformanceOptimizations: React.FC = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    // Add preconnect hints for third-party domains
    const preconnectDomains = [
      'https://fonts.googleapis.com',
      'https://fonts.gstatic.com',
      
      'https://api-iam.intercom.io',
      'https://widget.intercom.io',
      'https://js.intercomcdn.com',
    ];

    preconnectDomains.forEach(domain => {
      // Check if preconnect already exists
      const existing = document.querySelector(`link[rel="preconnect"][href="${domain}"]`);
      if (!existing) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });

    // Add dns-prefetch as fallback
    preconnectDomains.forEach(domain => {
      const existing = document.querySelector(`link[rel="dns-prefetch"][href="${domain}"]`);
      if (!existing) {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = domain;
        document.head.appendChild(link);
      }
    });

    // Optimize font loading with font-display: swap
    const fontLinks = document.querySelectorAll('link[href*="fonts.googleapis.com"]');
    fontLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href && !href.includes('display=')) {
        link.setAttribute('href', `${href}${href.includes('?') ? '&' : '?'}display=swap`);
      }
    });

  }, []);

  return null;
};
